export const PACKAGES_NAME_CY_DATA = "package-name-input"
export const PACKAGES_FILTER_CY_DATA = "packages-training-type-input"

export const PACKAGES_SEARCH_INPUT_CY_DATA = "packages-search-input";
export const PACKAGES_SEARCH_BUTTON_CY_DATA = "packages-search-button";
export const PACKAGES_GRID_CY_DATA = "packages-grid-input";
export const PACKAGES_GRID_ITEM_CY_DATA = "packages-grid-item-input";
export const PACKAGES_GRID_PAGINATION_CY_DATA = "pagination-input";
